import React, { useEffect, useState } from 'react';
import Toggle from 'react-toggle';

const ThemeSwitcher: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark-mode');
    }

    const viewModeElements = document.querySelectorAll('.view-mode');
    viewModeElements.forEach((el) => el.classList.remove('loading'));
  }, []);

  const toggleNightMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    document.documentElement.classList.toggle('dark-mode', newMode);

    const mode = newMode ? 'dark' : 'light';
    localStorage.setItem('theme', mode);

    const event = new Event('themeChange');
    window.dispatchEvent(event);
  };

  const label = window.nightModeLabel || 'Dark Mode';

  return (
    <label
      id="dark-mode-toggle"
      className="drawer-handheld-menu__menu-item drawer-handheld-menu__menu-item--dark-mode"
      htmlFor="theme-toggle-input"
    >
      <div className="h-d--flex h-align-items--center">
        <span className="drawer-handheld-menu__night-label link link--large link--nodecoration">{label}</span>
      </div>
      <Toggle
        id="theme-toggle-input"
        checked={isDarkMode}
        icons={false}
        onChange={toggleNightMode}
        aria-label="Toggle night mode"
      />
    </label>
  );
};

export default ThemeSwitcher;
